export const formatPriceRu = (price: number, withCurrency = true) => {
  const formattedPrice = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(price)
  if (formattedPrice === 'не число') {
    return '-'
  }
  return withCurrency ? `${formattedPrice}\u00A0₽` : formattedPrice
}
